import GeneratedPageHost from "./generated/GeneratedPageHost";

const PageView: React.FC = () => {
  return <GeneratedPageHost />;
};

export default PageView;
